module.exports = __webpack_public_path__ + "static/img/tp.9c4e566.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/tp.png
// module id = RAwz
// module chunks = 1